import { render, staticRenderFns } from "./KusBaseUploadBtn.vue?vue&type=template&id=0fb3e20d&scoped=true"
import script from "./KusBaseUploadBtn.vue?vue&type=script&lang=js"
export * from "./KusBaseUploadBtn.vue?vue&type=script&lang=js"
import style0 from "./KusBaseUploadBtn.vue?vue&type=style&index=0&id=0fb3e20d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3e20d",
  null
  
)

export default component.exports